import React, { useState, FC, KeyboardEvent, Fragment, MouseEvent } from 'react';
import { IconButton, Popover, TextField } from '@mui/material';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { useTranslation } from 'react-i18next';

type DiscountButtonProps = {
    onChange: (discountPercent: string) => void;
    disabled?: boolean;
};
const DiscountButton: FC<DiscountButtonProps> = ({ onChange, disabled }) => {
    const { t: translate } = useTranslation(['orders', 'actions-materials']);

    const [discountAnchorEl, setDiscountAnchorEl] = useState<null | HTMLElement>(null);
    const [discountValue, setDiscountValue] = useState<string>('');

    const handleDiscountClick = (event: MouseEvent<HTMLElement>) => {
        setDiscountAnchorEl(event.currentTarget);
        setDiscountValue('');
    };

    const handleDiscountClose = () => {
        setDiscountAnchorEl(null);
        setDiscountValue('');
    };

    const handleDiscountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDiscountValue(e.target.value.replace(/[^0-9.,]/g, ''));
    };

    const handleDiscountKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            if (discountValue) {
                const percent = parseFloat(discountValue);
                if (!isNaN(percent) && percent > 0 && percent <= 100) {
                    onChange(discountValue);
                } else {
                    onChange('0'); // Clear if invalid
                }
            }
            setTimeout(handleDiscountClose, 0);
        }
        if (e.key === 'Escape') {
            handleDiscountClose();
        }
    };

    return (
        <Fragment>
            <IconButton onClick={handleDiscountClick} disabled={disabled}>
                <LocalOfferIcon fontSize="inherit" sx={{ fontSize: '14px' }} />
            </IconButton>

            <Popover
                open={Boolean(discountAnchorEl)}
                anchorEl={discountAnchorEl}
                onClose={handleDiscountClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
                <TextField
                    autoFocus
                    label={translate('orders:DISCOUNT_PERCENT')}
                    size="small"
                    value={discountValue}
                    onChange={handleDiscountChange}
                    onKeyDown={handleDiscountKeyDown}
                    inputProps={{ inputMode: 'decimal', pattern: '[0-9.]*', style: { width: 80 } }}
                    sx={{ m: 1 }}
                />
            </Popover>
        </Fragment>
    );
};

export default DiscountButton;
